import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useGarage() {
  const [garage, setGarage] = useState({ engines: [], chassis: [] });
  const reload = useCallback(async () => {
    const [e, c] = await Promise.all([api.get("/garage/engines"), api.get("/garage/chassis")]);
    setGarage({ engines: e.data, chassis: c.data });
  }, []);
  useEffect(() => {
    reload();
  }, [reload]);
  return { garage, reload };
}
